import type { FaireProductEntity } from "../../entity_types/product";

export const p_zzsydxceff: FaireProductEntity = {
  token: "p_zzsydxceff",
  type: "product",
  name: "Balm Baby - Natural Chest Vapor Rub - Glass Jar",
  brandToken: "b_b3ffvix4",
  brandName: "Taylor's Naturals",
  imageUrl: "https://cdn.faire.com/fastly/486121f2ac8902b002745080333624b9f4f00898e44b7c602493f7ff4236f033.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.5,
  description: "An herbal infused, all natural balm for aiding in treating stuffy noses and chests and nausea, morning sickness and motion sickness. Also amazing as a deep tissue and muscle balm! Sports Massage Therapists rave about it's use for this!\n\n•\tPERFECT for cold / flu season!\n•\tPERFECT for sore muscles too!\n•\tPure and Natural, Hand Crafted in the USA\n•\tVegan, Non-GMO, Nut & Gluten Free, Cruelty Free\n•\t2oz glass jar \n•\tNo harsh chemicals, NO artificial binders or fragrances, etc.,\n                                         \nIngredients:  Organic extra virgin olive oil, organic raw shea butter, candelilla wax, essential oil blend of lavender, spearmint, pine, eucalyptus (smithii), and tocopherol (Vit. E)\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:42.464Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
